import { Stack } from 'expo-router';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { useNativeTabBarContentInset } from 'hooks/use-native-tab-bar-content-inset';
import { primitive } from 'styles/constants';

export default function MenuLayout() {
  const nativeTabBarContentInset = useNativeTabBarContentInset();

  return (
    <>
      <Stack
        screenOptions={{
          contentStyle: { backgroundColor: primitive.$mayoEggWhite },
          headerShown: false,
        }}
      >
        <Stack.Screen name="index" options={{ animation: 'none' }} />
        <Stack.Screen name="favorites" options={{ animation: 'none' }} />
        <Stack.Screen name="recent-items" options={{ animation: 'none' }} />
        {/* NOTE: modals are in (modals), section pages are in /menu/section for non-tabbed presentation */}
      </Stack>
      <FloatingViewCartFab extraBottomInset={nativeTabBarContentInset} />
    </>
  );
}
